<script setup lang="ts">

</script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.8902 6.46721L8.30685 2.74498C8.23039 2.69397 8.14054 2.66675 8.04862 2.66675C7.95671 2.66675 7.86685 2.69397 7.79039 2.74498L2.20705 6.46721C2.14331 6.50974 2.09106 6.56735 2.05494 6.63492C2.01882 6.70249 1.99995 6.77794 2 6.85456V12.9032C2 13.15 2.09804 13.3867 2.27255 13.5612C2.44707 13.7357 2.68376 13.8337 2.93056 13.8337H13.1667C13.4135 13.8337 13.6502 13.7357 13.8247 13.5612C13.9992 13.3867 14.0972 13.15 14.0972 12.9032V6.85456C14.0973 6.77794 14.0784 6.70249 14.0423 6.63492C14.0062 6.56735 13.9539 6.50974 13.8902 6.46721ZM2.93056 12.9032V7.75778L6.76329 10.4913C6.84221 10.5477 6.93676 10.578 7.03373 10.578H9.06351C9.16049 10.578 9.25504 10.5477 9.33396 10.4913L13.1667 7.75778V12.9032H2.93056Z" fill="#FEFEFF"/>
  </svg>
</template>

<style scoped lang="scss">

</style>